import Vue from 'vue'
import App from './App.vue'
import AppStartupError from './AppStartupError.vue'
import routes from './router'
import BootstrapVue from 'bootstrap-vue'
import vSelect from 'vue-select'
import vuejsDatepicker from 'vuejs-datepicker'
import "./vee-validate"
import AuthService from './services/msal'
import VueRouter from 'vue-router'
import axios from 'axios'
import SelectWithProvider from "./components/forms/SelectWithProvider"
import '@babel/polyfill'
import { ValidationObserver, ValidationProvider } from "vee-validate"
import "isomorphic-fetch"
import VueCurrencyInput from 'vue-currency-input'
import 'url-search-params-polyfill'
import i18n from './i18n'


Vue.component('v-select', vSelect);
Vue.component('v-datepicker', vuejsDatepicker);
Vue.component('form-select', SelectWithProvider);
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)


let apiBaseUrl = window.location.hostname == 'localhost' ? 'https://localhost:44351/api' : window.location.origin + '/api';

fetch(apiBaseUrl + '/config')
  .then(response => response.json()) // This is the important line you should have when using fetch
  .then(spaConfig => {

    const msalConfig = spaConfig.msalConfig;
    msalConfig.auth.redirectUri = window.location.origin; //this is dynamic due to diffrent domain, but if config came from API then it could be set withn API and then don't need this line

    const auth = new AuthService(msalConfig);
    Vue.prototype.$auth = auth;

    Vue.use(VueRouter);
    Vue.use(BootstrapVue);
    Vue.use(VueCurrencyInput, {
      globalOptions: {
        currency: null,  precision : {min: 0, max: 2} 
      }
    });

    Vue.config.productionTip = false;

    axios.defaults.baseURL = apiBaseUrl;
    axios.defaults.headers.common['Content-Type'] = "application/json";
    
    // NOTE: https://medium.com/@mateioprea/maintaining-api-authentication-using-axios-e70ba174da6
    //       https://stackoverflow.com/questions/35900230/axios-interceptors-and-asynchronous-login
    //      Catching an expired token as a 401 response interceptor https://medium.com/swlh/handling-access-and-refresh-tokens-using-axios-interceptors-3970b601a5da
    //
    axios.interceptors.request.use((config) => {
      let originalRequest = config;
      return auth.getIdToken()
        .then((tokenResponse) => {
          
          originalRequest.headers.Authorization = "Bearer " + tokenResponse;

          return Promise.resolve(originalRequest);
        }).catch(error => {
          return Promise.reject(error);
        });
    }, (error) => {
      return Promise.reject(error);
    });

    // Force a new token if we still get a 401 error after a request and try one more time
    axios.interceptors.response.use(response => response, error => {
      const originalRequest = error.config;
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        return auth.refreshIdToken()
          .then(tokenResponse => {
            // The new token will be applied in the request interceptor
            return axios(originalRequest);
          }).catch(error => {
            return Promise.reject(error);
          });
      }

      return Promise.reject(error);
    });


    // routes.push({ 
    //   path: spaConfig.hubUrl, 
    //   name: 'Home',
    //   beforeEnter() {location.href = spaConfig.hubUrl}
    // });
    
    const router = new VueRouter({
      mode: 'history', routes });

    router.beforeEach((to, from, next) => {
      if (!auth.isAuthenticated()) 
      {
        auth.signIn(); // ← trigger login
        // Do NOT call `next()` to cancel navigation
        // This stops the route change
      } else {
        next(); // proceed to route
      }
    })

    new Vue({
      router,
      i18n,

      //store,
      render: h => h(App)
    }).$mount('#app');

  }).catch(function (error) {

    Vue.use(BootstrapVue);
    new Vue({
      data: {
        errorMessage: error
      },
      render(h) {
        return h(AppStartupError, { props: { appData: this.errorMessage } })
      }
    }).$mount('#app');

  });
